import { defineComponent as _defineComponent } from 'vue'
import BCXIcon from '@/components/molecules/BCXIcon.vue';
import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXPaginationSwitcher',
  props: {
  showPrev: Boolean,
  showNext: Boolean,
  prevLabel: { type: String, default: '' },
  nextLabel: { type: String, default: '' },
  chevronSize: { type: Number, default: 16 },
  align: {
    type: String as PropType<'center' | 'left'>,
    default: 'center'
  }
},
  emits: ['next', 'prev'],
  setup(__props) {





return { __sfc: true,BCXIcon }
}

})